// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"c7e90bd0","62":"f879d78a","89":"a4000ced","129":"ef721a65","144":"88f35b82","230":"a79318e0","334":"70eee377","453":"6a5c0e41","503":"113544a2","731":"7ef4a2a6","754":"e9818824","802":"296954ef","841":"11f99fb8","848":"bee2398c","916":"3e547382"}[chunkId] + ".chunk.js";
};